import endpointVersion from '@/helpers/endpoint-version';
import store from '@/store';
import axios from 'axios';
import { getServiceBase } from './microservices';
export async function getSmsCampaignList(params) {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return await axios.get(`${getServiceBase()}/sms/campaign/list`, {
        headers: { Authorization: `Bearer ${tokenV3}` },
        params: { brand: brand.id, limit: params.limit, page: params.page },
    });
}
export async function getSmsBalance() {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return await axios.get(`${getServiceBase()}/sms/campaign/balance`, {
        headers: { Authorization: `Bearer ${tokenV3}` },
        params: { brand: brand.id },
    });
}
export async function getAudiences(term) {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return await axios.get('/action/getAudiences', {
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${tokenV3}` },
        params: {
            brand: brand.id,
            term,
        },
    });
}
export async function postSmsCampaign(data) {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const SCHEDULED = 4;
    const payload = {
        brand: brand.id,
        name: data.campaignName,
        status: SCHEDULED,
        audienceFk: data.audienceId,
        sentDate: data.sentDate,
        sent: 0,
        message: data.message,
    };
    return await axios.post(`${getServiceBase()}/sms/campaign/store`, payload, {
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
}
export async function postSendSmsTest(mobileNumber, message) {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const payload = {
        brand: brand.id,
        mobileNumber,
        message,
    };
    return await axios.post(`${getServiceBase()}/sms/campaign/send`, payload, {
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
}
export async function putActivateOrDeactivateSmsCampaign(campaignId, status) {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return await axios.put(`${getServiceBase()}/sms/campaign/update`, {
        brand: brand.id,
        campaignId,
        status,
    }, {
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
}
